module.exports = __webpack_public_path__ + "static/media/download.d9e957a3.svg";